import React from 'react';
import { infoPageStyles as styles } from './sharedStyles';

const Accessibility = () => {
  return (
    <div style={styles.pageContainer}>
      <div style={styles.header}>
        <h1 style={styles.headerTitle}>Accessibility Statement</h1>
        <p style={styles.headerSubtitle}>Committed to an inclusive experience</p>
      </div>

      <div style={styles.contentContainer}>
        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>Our Commitment</h2>
          <p style={styles.text}>
            Redbird Markets is committed to ensuring digital accessibility for people with disabilities. 
            We are continually improving the user experience for everyone and applying relevant accessibility standards.
          </p>
        </div>

        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>Accessibility Features</h2>
          <ul style={styles.list}>
            <li style={styles.listItem}><strong>Keyboard Navigation:</strong> Full functionality accessible via keyboard</li>
            <li style={styles.listItem}><strong>Screen Reader Compatible:</strong> Works with JAWS, NVDA, and VoiceOver</li>
            <li style={styles.listItem}><strong>Text Alternatives:</strong> Images include descriptive alt text</li>
            <li style={styles.listItem}><strong>Color Contrast:</strong> Meets WCAG 2.1 AA standards</li>
            <li style={styles.listItem}><strong>Responsive Design:</strong> Works on all devices and screen sizes</li>
            <li style={styles.listItem}><strong>Clear Navigation:</strong> Consistent and predictable layout</li>
            <li style={styles.listItem}><strong>Readable Fonts:</strong> Clear typography with adjustable sizes</li>
          </ul>
        </div>

        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>Standards</h2>
          <p style={styles.text}>
            We aim to conform to Level AA of the Web Content Accessibility Guidelines (WCAG) 2.1. 
            These guidelines explain how to make web content more accessible for people with disabilities.
          </p>
        </div>

        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>Assistive Technology Support</h2>
          <p style={styles.text}>
            Redbird Markets is designed to work with:
          </p>
          <ul style={styles.list}>
            <li style={styles.listItem}>Screen readers (JAWS, NVDA, VoiceOver)</li>
            <li style={styles.listItem}>Screen magnification software</li>
            <li style={styles.listItem}>Speech recognition software</li>
            <li style={styles.listItem}>Alternative input devices</li>
            <li style={styles.listItem}>Browser accessibility features</li>
          </ul>
        </div>

        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>Known Limitations</h2>
          <p style={styles.text}>
            While we strive for full accessibility, we acknowledge some limitations:
          </p>
          <ul style={styles.list}>
            <li style={styles.listItem}>User-uploaded images may lack descriptive alt text</li>
            <li style={styles.listItem}>Third-party payment interface (Stripe) may have separate accessibility features</li>
          </ul>
          <p style={styles.text}>
            We are actively working to address these limitations.
          </p>
        </div>

        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>ISU Accessibility Resources</h2>
          <ul style={styles.list}>
            <li style={styles.listItem}><strong>Student Access and Accommodation Services:</strong> Disability accommodations for students</li>
            <li style={styles.listItem}><strong>Technology Support:</strong> Assistive technology training and support</li>
            <li style={styles.listItem}><strong>Campus Resources:</strong> Additional accessibility services available on campus</li>
          </ul>
        </div>

        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>Feedback</h2>
          <p style={styles.text}>
            We welcome your feedback on the accessibility of Redbird Markets. If you encounter 
            accessibility barriers, please contact us:
          </p>
          <ul style={styles.list}>
            <li style={styles.listItem}>Email: <a href="mailto:redbirdmarket.isu@gmail.com" style={styles.link}>redbirdmarket.isu@gmail.com</a></li>
            <li style={styles.listItem}>Contact Form: <a href="/contact-us" style={styles.link}>Contact Us</a></li>
          </ul>
          <p style={styles.text}>
            We aim to respond to accessibility inquiries within 2 business days.
          </p>
        </div>

        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>Last Updated</h2>
          <p style={styles.text}>
            This accessibility statement was last reviewed on October 16, 2025.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Accessibility;
